import styled from "styled-components";

export const WorkerCounterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 100px;
`;
